export function changePageAnimationInit() {
  // Pobierz wszystkie linki wewnętrzne na stronie
  const internalLinks = document.querySelectorAll('a[href^="/"]');

  // Dodaj zdarzenie kliknięcia do każdego linku wewnętrznego
  internalLinks.forEach(function (link) {
    link.addEventListener("click", handleLinkClick);
  });
}

function handleLinkClick(event) {
  // Sprawdź, czy link nie zawiera kotwicy
  if (!this.href.includes("#")) {
    event.preventDefault(); // Zatrzymaj domyślne działanie linku
    const targetUrl = this.href; // Zachowaj docelowy URL

    // Dodaj klasę fade-out do zawartości strony
    document.body.classList.add("close-side-show");

    // Opóźnij przeładowanie strony o 1 sekundę (czas trwania animacji)
    setTimeout(function () {
      window.location.href = targetUrl; // Zmieniamy adres URL na docelowy
    }, 1000); // 1000 milisekund = 1 sekunda
  }
}
